"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKFormGroup = exports.GKFormGroupContext = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../../common");
exports.GKFormGroupContext = React.createContext({
    setDisabled: function () { return null; },
    setValidation: function () { return null; },
    setReadOnly: function () { return null; },
    setRequired: function () { return null; },
});
var GKFormGroup = function (props) {
    var _a = React.useState(), isValid = _a[0], setIsValid = _a[1];
    var _b = React.useState(), isDisabled = _b[0], setIsDisabled = _b[1];
    var _c = React.useState(), isReadOnly = _c[0], setIsReadOnly = _c[1];
    var _d = React.useState(), isRequired = _d[0], setIsRequired = _d[1];
    var providerValue = React.useMemo(function () { return ({
        setDisabled: setIsDisabled,
        setValidation: setIsValid,
        setReadOnly: setIsReadOnly,
        setRequired: setIsRequired,
    }); }, [setIsDisabled, setIsReadOnly, setIsRequired]);
    var classes = [
        isDisabled === true ? "disabled" : undefined,
        isValid === true
            ? "is-valid"
            : isValid === false
                ? "is-invalid"
                : undefined,
        isReadOnly === true ? "read-only" : undefined,
        isRequired === true ? "required" : undefined,
    ];
    var _e = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-form-group",
        className: classes.filter(function (c) { return c; }).join(" "),
    }), children = _e.children, invalidProp = _e.invalid, requiredProp = _e.required, otherProps = __rest(_e, ["children", "invalid", "required"]);
    // Update validation state only when the prop changes.
    React.useEffect(function () {
        if (invalidProp !== undefined) {
            setIsValid(!invalidProp);
        }
    }, [invalidProp]);
    // Update required state only when the prop changes.
    React.useEffect(function () {
        if (requiredProp !== undefined) {
            setIsRequired(requiredProp);
        }
    }, [requiredProp]);
    return (React.createElement(reactstrap_1.FormGroup, __assign({}, otherProps),
        React.createElement(exports.GKFormGroupContext.Provider, { value: providerValue }, children)));
};
exports.GKFormGroup = GKFormGroup;
